/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DealerUpgradeProposalSettingDto } from '../models/dealer-upgrade-proposal-setting-dto';
@Injectable({
  providedIn: 'root',
})
class DealerUpgradeProposalSettingClientService extends __BaseService {
  static readonly GetDealerUpgradeProposalSettingByDealeridGETPath = '/api/DealerUpgradeProposalSetting/GetDealerUpgradeProposalSetting/{dealerId}';
  static readonly SaveDealerUpgradeProposalSettingPOSTPath = '/api/DealerUpgradeProposalSetting/SaveDealerUpgradeProposalSetting';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param dealerId undefined
   */
  GetDealerUpgradeProposalSettingByDealeridGETResponse(dealerId: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DealerUpgradeProposalSetting/GetDealerUpgradeProposalSetting/${dealerId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param dealerId undefined
   */
  GetDealerUpgradeProposalSettingByDealeridGET(dealerId: number): __Observable<null> {
    return this.GetDealerUpgradeProposalSettingByDealeridGETResponse(dealerId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param request undefined
   */
  SaveDealerUpgradeProposalSettingPOSTResponse(request?: DealerUpgradeProposalSettingDto): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DealerUpgradeProposalSetting/SaveDealerUpgradeProposalSetting`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SaveDealerUpgradeProposalSettingPOST(request?: DealerUpgradeProposalSettingDto): __Observable<null> {
    return this.SaveDealerUpgradeProposalSettingPOSTResponse(request).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module DealerUpgradeProposalSettingClientService {
}

export { DealerUpgradeProposalSettingClientService }
